import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import type { Action } from './types.tsx';

export type SpotlightButtonProps = {
	onClick: (_: unknown, analyticsEvent: UIAnalyticsEvent) => void | Promise<void>;
	text: string;
	width?: string;
	onFocus?: () => void;
	appearance: 'primary' | 'link';
};

export const generateButtonAction = ({
	onClick,
	text,
	width,
	onFocus,
	appearance,
}: SpotlightButtonProps): Action => ({
	onClick,
	onFocus,
	text,
	appearance,
	theme: (current, themeProps) =>
		appearance === 'link'
			? {
					buttonStyles: {
						...current(themeProps).buttonStyles,
						color: token('color.text.discovery'),
					},
					spinnerStyles: current(themeProps).spinnerStyles,
				}
			: {
					buttonStyles: {
						...current(themeProps).buttonStyles,
						backgroundColor: token('color.icon.discovery'),
						color: token('color.text.inverse'),
						width: width && width,
					},
					spinnerStyles: current(themeProps).spinnerStyles,
				},
});

export const getAnalyticsMeta = (id: string) => ({
	id,
	packageName: 'jiraBulkOperationsCommon',
	teamName: 'deliveroo',
});
